import { Point } from "../Point";
import { Rectangle } from "../Rectangle";
import { cms_logging } from "../cms_logging";
import { Id_building, Id_drawing, Id_floor } from "../api/Identifiers";
import { State, get_state } from "../redux/State";
import { exists } from "../utils";

// static values. AWH TODO REMOVE once we move
let __statics_applied: boolean = false;


function __setup_statics() {
    if (!__statics_applied) {
        let sss: State = get_state();
        __statics_applied = true;
    }

}

interface DrawingJSON {
    // p0: number[],
    // p1: number[],
    // p2: number[],
    // building_p1: number[],
    // building_p2: number[],
    id_drawing: string;
    id_floor: number;
    id_building: number;
    z_index: number,
    location_description: string,
    drawing_description: string,
    // tiles_url: string,
    is_sitemap: boolean,

    idDrawing: string,            // AWH REMOVE
    idLocation: number,           // AWH REMOVE
    idParent: number,             // AWH REMOVE
    sortOrder: number,            // AWH REMOVE
    locationDescription: string,  // AWH REMOVE
}


export class Drawing {
    private _is_sitemap: boolean = false;
    // private _p0: Point;
    // private _p1: Point;
    // private _p2: Point;
    // private _building_p1: Point;
    // private _building_p2: Point;
    private _id_drawing: Id_drawing;
    private _id_floor: Id_floor;
    private _id_building: Id_building;
    private _location_description: string;
    private _drawing_description: string;
    private _z_index: number;
    //    private _tiles_url: string;

    public get id_building(): Id_building { return this._id_building; }
    public get id_floor(): Id_floor { return this._id_floor; }
    public get id(): Id_drawing { return this._id_drawing; }
    public get z_index(): number { return this._z_index; }
    public get location_description(): string { return this._location_description; }
    public get drawing_description(): string { return this._drawing_description; }
    public get tiles_url(): string { return this.drawing_info.tiles_path; }
    public get geo_ref(): Rectangle { return Rectangle.build(this.p1, this.p2); }

    public get building_geo_ref(): Rectangle {
        if (this.building_p1 === null) {
            return null;
        }
        return Rectangle.build(this.building_p1, this.building_p2);
    }

    private get drawing_info(): any {
        let r = get_state().drawings_info_data[this.id.value];
        if (!r) {
            r = {
                "anchor": { "p1": [0, 0], "p2": [0, 0] },
                "tiles_path": ""
            };
        }
        return r;
    }
    public get p0(): Point {
        let p0 = this.drawing_info.anchor.p0;
        if (!p0) {
            return Point.build(0, 0);
        }
        return Point.build_from_array(p0);
    }
    public get p1(): Point {
        let p1 = this.drawing_info.anchor.p1;
        if (!p1) {
            return Point.build(0, 0);
        }
        return Point.build_from_array(p1);
    }
    public get p2(): Point {
        let p2 = this.drawing_info.anchor.p2;
        if (!p2) {
            return Point.build(0, 0);
        }
        return Point.build_from_array(p2);
    }

    public get building_p1(): Point {
        let b1 = this.drawing_info.anchor.b1;
        if (!b1) {
            return null;
        }
        return Point.build_from_array(b1);
    }

    public get building_p2(): Point {
        let b2 = this.drawing_info.anchor.b2;
        if (!b2) {
            return null;
        }
        return Point.build_from_array(b2);
    }

    public get has_b1b2(): boolean {
        let retVal: boolean = false;
        if (exists(this.building_p1) && exists(this.building_p2)){
            retVal = true;
        }
        return retVal;
    }

    public get is_sitemap(): boolean {
        return this._is_sitemap;
    }

    public get is_dispalyable(): boolean {
        if(exists(this.tiles_url)){
            if(this.tiles_url !== ""){
                if (exists(this.geo_ref)){
                    return true;
                }
            }
        }
        return false;
    }

    public static reviver_from_clean(key: string, value: any) {
        if (key.toLowerCase() === "p0") {
            return Point.build_from_array(value);
        }
        if (key.toLowerCase() === "p1") {
            return Point.build_from_array(value);
        }
        if (key.toLowerCase() === "p2") {
            return Point.build_from_array(value);
        }
        if (key.toLowerCase() === "id_building") {
            return Id_building.wrap(value);
        }
        if (key.toLowerCase() === "id_drawing") {
            return Id_drawing.wrap(value);
        }
        if (key.toLowerCase() === "id_floor") {
            return Id_floor.wrap(value);
        }
        return value; // return unchanged
    }

    public static build_from_clean(clean_drawing: any) {
        let r: Drawing = new Drawing();
        let j: any = JSON.parse(JSON.stringify(clean_drawing), Drawing.reviver_from_clean);
        // r._p0 = Point.build_from_array(clean_drawing.p0)
        // r._p1 = Point.build_from_array(clean_drawing.p1)
        // r._p2 = Point.build_from_array(clean_drawing.p2)
        // r._building_p1 = Point.build_from_array(clean_drawing.building_p1);
        // r._building_p2 = Point.build_from_array(clean_drawing.building_p2);
        r._id_building = Id_building.wrap(clean_drawing.id_building);
        r._id_drawing = Id_drawing.wrap(clean_drawing.id_drawing);
        r._id_floor = Id_floor.wrap(clean_drawing.id_floor);
        r._z_index = clean_drawing.z_index;
        r._location_description = clean_drawing.location_description;
        r._drawing_description = clean_drawing.drawing_description;
        //r._tiles_url = clean_drawing.tiles_url;
        r._is_sitemap = clean_drawing.is_sitemap;
        return r;
    }
    public static build_from_raw(raw_drawing: any) {
        __setup_statics();
        let r: Drawing = new Drawing();

        function api_error(message: string) {
            cms_logging.api_error(message, "drawing", raw_drawing);

        }
        function getPoint(key: string, default_value: number, floorplan: any) {
            let point: number = default_value;
            if (!_.has(floorplan, key)) {
                //console.error("drawing " + key + " does not exist")
            }
            else {
                point = floorplan[key];
                if (point == null) {
                    //    console.error("drawing " + key + " does not exist")
                    point = default_value;
                }
            }
            return point;
        }

        if (!raw_drawing.idDrawing) {
            api_error("missing idDrawing");
            return null;
        }
        if (!raw_drawing.idLocation) {
            api_error("missing idLocation");
            return null;
        }
        if (!raw_drawing.idParent) {
            api_error("missing idParent");
            return null;
        }
        // if (!raw_drawing.p1xCoord) {
        //     api_error("missing p1xCoord");//. idParent: " + raw_drawing.idParent + " location: " + raw_drawing.idLocation + " drawingDescription: " + raw_drawing.drawingDescription, 'drawing', raw_drawing);
        //     return null;
        // }
        // if (!raw_drawing.p1yCoord) {
        //     api_error("missing p1yCoord");
        //     return null;
        // }
        // if (!raw_drawing.p2xCoord) {
        //     api_error("missing p2xCoord");
        //     return null;
        // }
        // if (!raw_drawing.p2yCoord) {
        //     api_error("missing p2yCoord"); //. idParent: " + raw_drawing.idParent + " location: " + raw_drawing.idLocation  + " drawingDescription: " + raw_drawing.drawingDescription);
        //     return null;
        // }
        // r._p0 = Point.build(getPoint("p0xCoord", 0, raw_drawing), getPoint("p0yCoord", 0, raw_drawing));
        // r._p1 = Point.build(getPoint("p1xCoord", null, raw_drawing), getPoint("p1yCoord", null, raw_drawing));
        // r._p2 = Point.build(getPoint("p2xCoord", null, raw_drawing), getPoint("p2yCoord", null, raw_drawing));
        // r._building_p1 = Point.build(getPoint("buildingP1XCoord", null, raw_drawing), getPoint("buildingP1YCoord", null, raw_drawing));
        // r._building_p2 = Point.build(getPoint("buildingP2XCoord", null, raw_drawing), getPoint("buildingP2YCoord", null, raw_drawing));
        r._id_drawing = Id_drawing.wrap(raw_drawing.idDrawing);
        r._id_floor = Id_floor.wrap(raw_drawing.idLocation);
        r._id_building = Id_building.wrap(raw_drawing.idParent);
        r._z_index = raw_drawing.sortOrder;
        r._location_description = raw_drawing.locationDescription;
        r._drawing_description = raw_drawing.drawingDescription;

        // if (r._id_drawing.toString() === "013a0375-5ee2-47fd-9740-9b2f347cd4a5"){
        //     cms_logging.printf("here????????????");
        //     fetchSiteMap();
        // }

        return r;
    }


    public static build_from_raw_sitemap(raw_drawing: any) {
        __setup_statics();
        let r: Drawing = new Drawing();
        r._is_sitemap = true;

        console.debug(r.is_sitemap);
        function getPoint(key: string, default_value: number, floorplan: any) {
            let point: number = default_value;
            if (!_.has(floorplan, key)) {
                //console.error("drawing " + key + " does not exist")
            }
            else {
                point = floorplan[key];
                if (point == null) {
                    //    console.error("drawing " + key + " does not exist")
                    point = default_value;
                }
            }
            return point;
        }

        if (!raw_drawing.idDrawing) {
            cms_logging.api_error("missing idDrawing", "drawinglocations/s", raw_drawing);
            return null;
        }
        if (!raw_drawing.idLocation) {
            cms_logging.api_error("missing idLocation", "drawinglocations/s", raw_drawing);
            return null;
        }

        //        r._p0 = Point.build(getPoint("p0xCoord", 0, raw_drawing), getPoint("p0yCoord", 0, raw_drawing));
        cms_logging.api_error("P1 P2 are stubbed", "");
        //        r._p1 = Point.build(getPoint("p1xCoord", null, raw_drawing), getPoint("p1yCoord", null, raw_drawing));
        //        r._p2 = Point.build(getPoint("p2xCoord", null, raw_drawing), getPoint("p2yCoord", null, raw_drawing));
        // if (!r._p1) {
        //     cms_logging.error("STUBBED P1P2")
        //     cms_logging.api_error('missing p1', 'drawinglocations/s', raw_drawing);
        //     r._p1 = Point.build_from_array([0, 0]);
        // }
        // if (!r._p2) {
        //     cms_logging.error("STUBBED P1P2")
        //     cms_logging.api_error('missing p1', 'drawinglocations/s', raw_drawing);
        //     r._p2 = Point.build_from_array([1000, 1000]);
        // }

        r._id_drawing = Id_drawing.wrap(raw_drawing.idDrawing);
        r._id_floor = Id_floor.wrap(raw_drawing.idLocation);
        r._id_building = Id_building.wrap(raw_drawing.idLocation);
        // r._z_index = raw_drawing.sortOrder;
        r._location_description = raw_drawing.locationDescription;
        r._drawing_description = raw_drawing.drawingDescription;
        
        return r;
    }

    public toJSON(): DrawingJSON {
        // return r;
        let p0: number[] = [0, 0];
        let p1: number[] = [null, null];
        let p2: number[] = [null, null];
        let building_p1: number[] = [null, null];
        let building_p2: number[] = [null, null];
        // if (this._p0 !== null) {
        //     p0 = this._p0.toArray()
        // }
        // if (this._p1) {
        //     p1 = this._p1.toArray()
        // }
        // if (this._p2) {
        //     p2 = this._p2.toArray()
        // }

        // if (this._building_p1) {
        //     building_p1 = this._building_p1.toArray()
        // }

        // if (this._building_p2) {
        //     building_p2 = this._building_p2.toArray()
        // }

        const r: DrawingJSON = {
            //            p0: p0,
            //            p1: p1,
            //            p2: p2,
            //            building_p1: building_p1,
            //            building_p2: building_p2,
            id_drawing: this._id_drawing.value,
            id_floor: this._id_floor.value,
            id_building: this._id_building.value,
            z_index: this._z_index,
            location_description: this._location_description,
            idDrawing: this._id_drawing.value,
            idLocation: this._id_floor.value,
            idParent: this._id_building.value,
            sortOrder: this._z_index,
            locationDescription: this._location_description,
            drawing_description: this._drawing_description,
            //            tiles_url: this._tiles_url,
            is_sitemap: this.is_sitemap
        };
        return r;
    }


}

/**
 * __clean_raw_floorplan_data()
 * @param {floorplan_data}   The raw output of /api/DrawingLocations/F and cleans it up.
 * @return {array of floorplans} cleaned up floorplan data
 1. cleans up the names (idParent -> id_building, etc.)
 2. fills in any missing data
 3. reports errors
 */
export function clean_raw_floorplan_data(floorplan_data: any): any {
    let floorplans: any[] = [];

    floorplan_data.forEach((raw_drawing: any) => {
        floorplans.push(Drawing.build_from_raw(raw_drawing).toJSON());
    });
    return floorplans;
}



